<mat-card>
  <mat-card-content>

    <div class="print-header">
      @if(hospitalInfo.logo){
      <img class="rounded-circle" [src]="staticimagepath + hospitalInfo.logo" width="60"
        fallbackImage="assets/images/svgs/hospital.png" />
      }@else {
      <img class="rounded-circle" [src]="'assets/images/svgs/hospital.png'" width="60" />
      }
      <h2>{{ 'PHARMACY.PHARMACY_RECEIPT' | translate }}</h2>
    </div>

    <div class="print-content">
      <div class="print-line">
        <span><strong>{{ 'PHARMACY.BILL_NO' | translate }}:</strong> {{ billResult.billNo }}</span>
        <span><strong>{{ 'PHARMACY.DATE' | translate }}:</strong> {{ billResult.billDate | date:'dd/MM/yyyy' }}</span>
      </div>

      <div class="print-line">
        <span><strong>{{ 'LABEL.PATIENT_NAME' | translate }}:</strong> {{ billResult.patientName }}</span>
        <span><strong>{{ 'LABEL.PATIENT_NO' | translate }}:</strong> {{ billResult.patientNumber }}</span>
      </div>
      <div class="print-line">
        <span>
          <strong>{{ 'LABEL.AGE' | translate }}/{{ 'LABEL.GENDER' | translate }}:</strong>
          {{ billResult.patientAge }} / {{ billResult.patientGender }}
        </span>
        <span><strong>{{ 'LABEL.MOBILE_LABEL' | translate }}:</strong> {{ billResult.patientMobile }}</span>
      </div>
      <div class="print-line" *ngIf="billResult.patientAddress">
        <span class="full-width"><strong>{{ 'LABEL.ADDRESS_LABEL' | translate }}:</strong> {{ billResult.patientAddress }}</span>
      </div>
      <div class="print-line" *ngIf="billResult.doctorName">
        <span><strong>{{ 'PHARMACY.PRESCRIBED_BY' | translate }}:</strong> {{ billResult.doctorName }}</span>
        <span><strong>{{ 'PHARMACY.CATEGORY' | translate }}:</strong> {{ 'PHARMACY.SELF_PAY' | translate }}</span>
      </div>

      <hr>

      <div class="print-table-wrapper">
        <table class="table table-bordered table-striped m-0">
          <thead>
            <tr>
              <th class="text-left">{{ 'LABEL.NO' | translate }}.</th>
              <th class="text-left">{{ 'PHARMACY.PRODUCT_NAME' | translate }}</th>
              <th class="text-left">{{ 'PHARMACY.BATCH_NO' | translate }}</th>
              <th class="text-left">{{ 'PHARMACY.EXP_DATE' | translate }}</th>
              <th class="text-right">{{ 'PHARMACY.QTY' | translate }}</th>
              <th class="text-right">{{ 'PHARMACY.MRP' | translate }} (&#8377;)</th>
              <th class="text-right">{{ 'PHARMACY.GST' | translate }}%</th>
              <th class="text-right">{{ 'PHARMACY.TOTAL_AMOUNT' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of billResult.items; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="text-left">{{ item.drugName }}</td>
              <td class="text-left">{{ item.batchNo }}</td>
              <td class="text-left">{{ item.expiryDate | date:'MM/yyyy' }}</td>
              <td class="text-right">{{ item.quantity }}</td>
              <td class="text-right">{{ item.unitPrice | indianCurrency }}</td>
              <td class="text-right">{{ item.gstPercentage }}%</td>
              <td class="text-right">{{ item.totalAmount | indianCurrency }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr>

      <div class="no-break-section">
        <div class="text-right">
          <p><strong>{{ 'PHARMACY.SUB_TOTAL' | translate }}:</strong> {{ billResult.subTotal | indianCurrency }}</p>
          <p><strong>{{ 'PHARMACY.TOTAL_GST' | translate }}:</strong> {{ billResult.totalGST | indianCurrency }}</p>
          <p *ngIf="billResult.discount">
            <strong>{{ 'PHARMACY.DISCOUNT' | translate }}:</strong> {{ billResult.discount | indianCurrency }}
          </p>
          <p *ngIf="billResult.roundOff">
            <strong>{{ 'PHARMACY.ROUND_OFF' | translate }}:</strong> {{ billResult.roundOff | indianCurrency }}
          </p>
          <h3><strong>{{ 'PHARMACY.GRAND_TOTAL' | translate }}:</strong> {{ billResult.amount | indianCurrency }}</h3>
        </div>
      </div>

      <br>
      <div class="print-line" *ngIf="billResult.createdBy">
        <span>
          <strong>{{ 'PHARMACY.BILL_GENERATED_BY' | translate }}:</strong> {{ billResult.createdBy }}
        </span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
